<template>
  <div class="arrow">
    <slot></slot>
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1200 120"
      preserveAspectRatio="none"
      :class="getFromColor"
    >
      <path
        d="M598.97 114.72L0 0 0 120 1200 120 1200 0 598.97 114.72z"
        :class="getToColor"
      ></path>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'ArrowSeparator',
  props: {
    from: { type: String, required: true },
    to: { type: String, required: true },
  },
  computed: {
    getFromColor() {
      return `from-${this.from}`;
    },
    getToColor() {
      return `to-${this.to}`;
    },
  },
};
</script>
<style scoped lang="scss">
.arrow {
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  & svg {
    position: relative;
    display: block;
    width: calc(100% + 1.3px);
    height: 70px;
  }
}
.to-red {
  fill: $red;
}
.to-black {
  fill: $black;
}
.to-grey,
.to-gray {
  fill: $grey;
}
.to-white {
  fill: $white;
}

.from-red {
  background-color: $red;
}
.from-black {
  background-color: $black;
}
.from-grey,
.from-gray {
  background-color: $grey;
}
.from-white {
  background-color: $white;
}

@include media-breakpoint-up(lg) {
  .arrow {
    & svg {
      height: 140px;
    }
  }
}
</style>
